import type { U3204ConversationSearchRow } from '../U3204Service';

export type U3204ConversationTitlePatch = {
  conversationId: string;
  title: string;
  version: number;
};

/**
 * Met à jour title et version d'une conversation dans la liste sidebar (BL-0163).
 */
export function u3204PatchConversationTitleInList(
  conversations: U3204ConversationSearchRow[],
  patch: U3204ConversationTitlePatch,
): U3204ConversationSearchRow[] {
  const index = conversations.findIndex((c) => c.id === patch.conversationId);
  if (index === -1) {
    return conversations;
  }

  return conversations.map((conversation, i) =>
    i === index
      ? {
          ...conversation,
          title: patch.title,
          version: patch.version,
          titleAutoGenerated: true,
        }
      : conversation,
  );
}
